import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import notiGif from './assets/NotiGifs.gif';
import { IResNotification } from 'services/shop/types/setting';
import DOMPurify from 'dompurify';
import shopSelectors from 'services/shop/selectors';

export type NotificationModalRef = {
  open: (data?: IResNotification) => void;
};

type Props = {};

const NotificationModal = forwardRef<NotificationModalRef, Props>((_, ref) => {
  const notificationShop = shopSelectors.data.notification();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<IResNotification>();

  useEffect(() => {
    if (notificationShop) {
      setData(notificationShop);
      setOpen(true);
    }
  }, [notificationShop]);

  const handleClose = () => {
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open(data) {
      setData(data);
      setOpen(true);
    },
  }));

  return (
    <ModalStyled
      open={open}
      title={null}
      footer={null}
      centered
      destroyOnClose
      width={'343px'}
      closable={false}
      maskStyle={{
        background: 'rgba(0, 0, 0, 0.40)',
        backdropFilter: 'blur(25px)',
      }}
    >
      <Container>
        <Wrapper>
          <div className='item-header'>
            <div>{data?.title}</div>
          </div>
          <div className='item-icon'>
            <img src={notiGif} alt='Notification animation' width={132} height={132} />
          </div>
          <div
            className='item-label'
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(data?.description || ''),
            }}
          />
        </Wrapper>
        <div className='icon-close' onClick={handleClose}>
          <IcClose />
        </div>
      </Container>
    </ModalStyled>
  );
});

NotificationModal.displayName = 'NotificationModal';

export default NotificationModal;

const ModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 32px;
  }
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border-radius: 32px;
  background: #fff;
  .icon-close {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
    aspect-ratio: 1/1;
  }
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  .item-header {
    margin: auto;
    width: 80%;
    align-self: stretch;
    color: #1d2129;
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.48px;
  }
  .item-icon {
    align-self: stretch;
    display: flex;
    justify-content: center;
  }
  .item-label {
    align-self: stretch;
    color: #1d2129;
    text-align: center;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.28px;
    .special {
      font-weight: 600;
    }
  }
`;

const IcClose = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='33' height='33' viewBox='0 0 33 33' fill='none'>
    <path
      d='M7.55727 7.55715C8.07797 7.03645 8.92219 7.03645 9.44289 7.55715L16.5001 14.6143L23.5573 7.55715C24.078 7.03645 24.9222 7.03645 25.4429 7.55715C25.9636 8.07785 25.9636 8.92207 25.4429 9.44277L18.3857 16.5L25.4429 23.5571C25.9636 24.0778 25.9636 24.9221 25.4429 25.4428C24.9222 25.9635 24.078 25.9635 23.5573 25.4428L16.5001 18.3856L9.44289 25.4428C8.92219 25.9635 8.07797 25.9635 7.55727 25.4428C7.03657 24.9221 7.03657 24.0778 7.55727 23.5571L14.6145 16.5L7.55727 9.44277C7.03657 8.92207 7.03657 8.07785 7.55727 7.55715Z'
      fill='#1D2129'
    />
  </svg>
);
